import { render, staticRenderFns } from "./insertExamDialog.vue?vue&type=template&id=0dbb6041&scoped=true&"
import script from "./insertExamDialog.vue?vue&type=script&lang=js&"
export * from "./insertExamDialog.vue?vue&type=script&lang=js&"
import style0 from "./insertExamDialog.vue?vue&type=style&index=0&id=0dbb6041&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbb6041",
  null
  
)

export default component.exports